import {testIdProps} from '@github-ui/test-id-props'
import {NavList} from '@primer/react'
import {memo} from 'react'

import {PotentiallyDirty} from '../../../../components/potentially-dirty'
import {NavLinkActionListItem} from '../../../../components/react-router/action-list-nav-link-item'
import styles from './chart-link.module.css'

type ChartLinkProps = Omit<React.ComponentProps<typeof NavList.Item>, 'ref'> & {
  to: string
  isDirty: boolean
  isActive: boolean
  children: string
  trailingVisual?: React.ReactElement | null
  leadingVisual?: React.ReactElement | null
  ref?: React.Ref<HTMLAnchorElement>
}

export const ChartLink = memo(function ChartLink({
  ref,
  to,
  isActive,
  children,
  isDirty,
  leadingVisual = null,
  trailingVisual = null,
  ...props
}: ChartLinkProps) {
  return (
    <NavLinkActionListItem to={to} isActive={isActive} end {...props} ref={ref}>
      {/* eslint-disable-next-line primer-react/direct-slot-children */}
      {leadingVisual ? <NavList.LeadingVisual>{leadingVisual}</NavList.LeadingVisual> : null}
      <div className={styles.Box}>
        {children}
        {!isActive && isDirty ? (
          <PotentiallyDirty
            isDirty
            hideDirtyState={false}
            className={styles.PotentiallyDirty}
            {...testIdProps('my-chart-navigation-item-dirty')}
          />
        ) : null}
      </div>
      {trailingVisual ? (
        /* eslint-disable-next-line primer-react/direct-slot-children */
        <NavList.TrailingVisual className="pointer-events-auto">{trailingVisual}</NavList.TrailingVisual>
      ) : null}
    </NavLinkActionListItem>
  )
})
